import Phaser from 'phaser';
import { CELL_SIZE } from '../config/constants';
import { getGameplayColorHex } from '../config/colors';
import { reducedParticles, fxDisabled } from '../config/particleConfig';

export class CubeSprite extends Phaser.GameObjects.Image {
  readonly gridRow: number;
  readonly gridCol: number;
  readonly colorIndex: number;

  constructor(scene: Phaser.Scene, gridRow: number, gridCol: number, x: number, y: number, colorIndex: number, isSnake = false, cellSize: number = CELL_SIZE) {
    const textureKey = isSnake ? `snake-cube-${colorIndex}` : `cube-${colorIndex}`;
    super(scene, x, y, textureKey);
    this.gridRow = gridRow;
    this.gridCol = gridCol;
    this.colorIndex = colorIndex;
    this.setDisplaySize(cellSize, cellSize);
    scene.add.existing(this);
  }

  destroyWithAnimation(): void {
    // Instant destroy when FX disabled
    if (fxDisabled) {
      this.destroy();
      return;
    }

    // Particle burst (skipped during win speed-up to avoid 50+ simultaneous emitters)
    if (!reducedParticles) {
      const tint = getGameplayColorHex(this.colorIndex);
      const emitter = this.scene.add.particles(this.x, this.y, 'particle', {
        speed: { min: 30, max: 90 },
        scale: { start: 0.9, end: 0 },
        alpha: { start: 1, end: 0 },
        lifespan: 350,
        tint,
        emitting: false,
      });
      emitter.explode(6);
      this.scene.time.delayedCall(400, () => emitter.destroy());
    }

    // Pop + fade
    this.scene.tweens.add({
      targets: this,
      scaleX: 1.4,
      scaleY: 1.4,
      alpha: 0,
      duration: 180,
      ease: 'Back.easeIn',
      onComplete: () => this.destroy(),
    });
  }
}
